import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types';
import { Button, Media } from 'react-bootstrap'
import { useHistory } from "react-router-dom";
import AddIcon from './Icon/AddIcon';
import ic_files_empathy from '../images/ic_files_empathy.svg'

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Paper from '@material-ui/core/Paper';
import { reqRoles } from '../service'
import { Cookies } from 'react-cookie'
import { Roles } from '../utils/constants';

const cookies = new Cookies()

const rows = [
];
function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}
const headCells = [
  { id: 'name', numeric: false, disablePadding: true, label: 'Name' },
  { id: 'calories', numeric: true, disablePadding: false, label: 'Sevice Permission' },
  { id: 'fat', numeric: true, disablePadding: false, label: 'Member' }
];
function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead className="text-muted">
      <TableRow>

        {headCells.map((headCell) => (
          <TableCell className="text-muted text-uppercase"
            key={headCell.id}
            align={headCell.numeric ? 'left' : 'left'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}

            </TableSortLabel>
          </TableCell>
        ))}
        <TableCell></TableCell>
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};


const Dashboard = () => {
  //const [person] = useRecoilState(personState)
  // const goRoleDetail()  {
  //   history.push({
  //     pathname:'/dashboard',
  //     search:'',
  //   })
  //   history.go(0)
  // }
  let history = useHistory();
  const [lists, setList] = useState([])

  // function goRoleDetail() {
  //   history.push({
  //     pathname: '/role-detail',
  //     search: '',
  //   })
  //   history.go(0)
  // }
  function goCreateRole() {
    history.push({
      pathname: '/create',
      search: '',
    })
    history.go(0)
  }



  useEffect(() => {
    requestRole()
  }, [])

  function requestRole() {
    reqRoles().then(res => {
      // console.log(res.result)
      setList(res.result)
    }).catch(err => {
      console.log(err)
    })
  }

  // table

  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('calories');
  const [selected, setSelected] = React.useState([]);
  const [page] = React.useState(0);
  const [rowsPerPage] = React.useState(25);



  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = rows.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, id) => {
    history.push({
      pathname: 'role-detail/'+id,
      search: '',
    })
    history.go(0)
    // const selectedIndex = selected.indexOf(name);
    // let newSelected = [];

    // if (selectedIndex === -1) {
    //   newSelected = newSelected.concat(selected, name);
    // } else if (selectedIndex === 0) {
    //   newSelected = newSelected.concat(selected.slice(1));
    // } else if (selectedIndex === selected.length - 1) {
    //   newSelected = newSelected.concat(selected.slice(0, -1));
    // } else if (selectedIndex > 0) {
    //   newSelected = newSelected.concat(
    //     selected.slice(0, selectedIndex),
    //     selected.slice(selectedIndex + 1),
    //   );
    // }

    // setSelected(newSelected);
  };

  // const handleChangePage = (event, newPage) => {
  //   setPage(newPage);
  // };

  // const handleChangeRowsPerPage = (event) => {
  //   setRowsPerPage(parseInt(event.target.value, 10));
  //   setPage(0);
  // };
  const isSelected = (name) => selected.indexOf(name) !== -1;

  const emptyRows = rowsPerPage - Math.min(rowsPerPage, lists.length - page * rowsPerPage);
  // menu list
  // const [anchorEl, setAnchorEl] = React.useState(null);

  // const handleClickMenu = (event) => {
  //   setAnchorEl(event.currentTarget);
  // };

  // const handleClose = () => {
  //   setAnchorEl(null);
  // };

  return (
    <div className="pt-3 pb-2 mb-3">
      {cookies.get('profile') ? ( cookies.get('profile').super_role === Roles.SUPER ?
      <div className="d-flex justify-content-between" >
        <Media>
          
        </Media>

        <div className="d-flex justify-content-end">
          <div className="d-flex bd-highlight mt-3">
            <div className="flex-grow-1 bd-highlight">
              {/* <div className="input-group mb-2">
                <div className="input-group-prepend">
                  <div className="input-group-text bg-white pr-0"><SearchIcon></SearchIcon></div>
                </div>
                <input type="text" className="form-control border-left-0" id="inlineFormInputGroup" placeholder="Search Members" />
              </div> */}
            </div>
            {/* <div className="bd-highlight"></div> */}
            <div className="bd-highlight ml-4">
              <form className="form-inline">
                <Button variant="light" className="mb-2 border" onClick={goCreateRole}><AddIcon></AddIcon> Create Group</Button>
                <div className="form-group mx-sm-3 mb-2">
                  {/* <input type="text" readonly className="form-control-plaintext" id="staticEmail2" value=": ThaiBev" /> */}
                </div>
              </form>

            </div>
          </div>
        </div>

      </div> : <p>เลือกแอพเมนูด้านซ้าย</p>) : ''}
      {/*{cookies.get('profile') ? ( cookies.get('profile').super_role === Roles.SUPER ? */}
      {cookies.get('profile') ?
      <Paper className="mt-2 shadow-none">
        {/* <EnhancedTableToolbar numSelected={selected.length} /> */}
        <TableContainer>
          <Table

            aria-labelledby="tableTitle"
            size={'medium'}
            aria-label="enhanced table"
          >
            <EnhancedTableHead
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={rows.length}
            />
            <TableBody>

              {lists.length === 0 ? (
                <>
                  <TableRow style={{ height: (15) * emptyRows }}>
                    <TableCell colSpan={6} className="text-center">
                      <img
                        width={40}
                        height={40}
                        className="m-3"
                        src={ic_files_empathy}
                        alt="Generic placeholder"
                      />
                      <p>ยังไม่มีข้อมูล</p>
                    </TableCell>
                  </TableRow>
                </>
              ) : (
                  <>

                    {stableSort(lists, getComparator(order, orderBy))
                      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((list, index) => {
                        const isItemSelected = isSelected(list.name);
                        const labelId = `enhanced-table-checkbox-${index}`;

                        return (
                          <TableRow
                            hover
                            onClick={(event) => handleClick(event, list.id)}
                            role="checkbox"
                            aria-checked={isItemSelected}
                            tabIndex={-1}
                            key={list.id}
                            selected={isItemSelected}
                          >

                            <TableCell component="th" id={labelId} scope="row">
                              {list.name}
                            </TableCell>
                            <TableCell align="left">{ list.apps ? list.apps.map((app, index) => {
                              return (
                                app.route.name
                              )
                            }) : ''}
                            </TableCell>
                            <TableCell align="right">{list.users ? list.users.length : '0'} Members</TableCell>
                            <TableCell align="right">
                              {/* <Button variant="link" onClick={handleClickMenu}>
                                <MoreVertIcon></MoreVertIcon>
                              </Button>
                              <Menu
                                id="simple-menu"
                                anchorEl={anchorEl}
                                keepMounted
                                open={Boolean(anchorEl)}
                                onClose={handleClose}
                              >
                                <MenuItem onClick={handleClose}>Delete</MenuItem>
                                <MenuItem onClick={handleClose}>Duplicate</MenuItem>

                              </Menu> */}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                  </>
                )
              }
            </TableBody>
          </Table>
        </TableContainer>
        {/* <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        /> */}
      {/* </Paper> : '') : ''} */}
      </Paper> : ''}
    </div>
  )
}

export default Dashboard